import downloadFlow from "../components/modals/download-flow-modal";
import iconShare from "../components/modals/icon-share-modal";
import aboutVideoModal from "../components/modals/about-video-modal";
import auth from "../components/auth/auth-modal";
import welcomeModal from "../components/modals/welcome-modal";

export const DOWNLOAD_FLOW = downloadFlow;
export const ICON_SHARE = iconShare;
export const AUTH = auth;
export const ABOUT_VIDEO_MODAL = aboutVideoModal;
export const WELCOME_MODAL = welcomeModal;

export const modalTypes = {
    DOWNLOAD_FLOW: "DOWNLOAD_FLOW",
    ICON_SHARE: "ICON_SHARE",
    AUTH: "AUTH",
    ABOUT_VIDEO_MODAL: "ABOUT_VIDEO_MODAL",
    WELCOME_MODAL: "WELCOME_MODAL"
};
